import { render } from "./UserEntityLink.vue?vue&type=template&id=1e2c24a8&scoped=true"
import script from "./UserEntityLink.vue?vue&type=script&lang=js"
export * from "./UserEntityLink.vue?vue&type=script&lang=js"

import "./UserEntityLink.vue?vue&type=style&index=0&id=1e2c24a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2c24a8"]])

export default __exports__